export const MESSAGE_ROLE = {
  USER: "user",
  ASSISTANT: "assistant",
} as const
export type MessageRole = (typeof MESSAGE_ROLE)[keyof typeof MESSAGE_ROLE]

export const ASSISTANT_STATUSES = {
  PROCESSING: "processing",
  COMPLETED: "completed",
  ERROR: "error",
  UNAUTHORIZED: "unauthorized",
} as const
export type AssistantStatus = (typeof ASSISTANT_STATUSES)[keyof typeof ASSISTANT_STATUSES]

export interface ChatMessage {
  role: MessageRole
  content: string
  assistantId?: string
}
export type ChatMessages = ChatMessage[]

/** Firestore Timestamp as serialized over the socket. */
export interface FirestoreTimestamp {
  _seconds: number
  _nanoseconds: number
}

export interface Thread {
  threadId: string
  userId: string
  appleToken: string | null
  assistantId: string
  createdAt: FirestoreTimestamp
  /** Last activity, bumped every turn. Absent on threads created before the backend
   *  added it — callers fall back to `createdAt`. */
  lastMessageAt?: FirestoreTimestamp
}

export interface ChatsMessage {
  assistantId: string
  message: string | null
}

export interface UnreadAdvisor {
  id: string
  message: string | null
}

export interface ChatStartedResponse {
  assistantId: string
  name: string
}

export interface ChatStoppedResponse {
  assistantReply: {
    type: string
    text: { value: string; annotations: [] }
  }
  threadId: string
  assistantId: string
}

export interface AssistantMessageResponse {
  assistantReply: {
    type: "text"
    text: { value: string; annotations: [] }
  }
  threadId: string
  assistantId: string
}

export interface ChatBalanceResponse {
  used_credits: number
  remaining_credits: number
}

export interface AssistantStatusResponse {
  status: AssistantStatus
  message: string
  assistantId: string
}

/** Minimal palm-reading payload persisted to storage (palm reading itself is out of scope). */
export type PalmReadingData = Record<string, unknown> | null
